import { SpkFarmSkeleton } from './components/skeleton/SpkFarmSkeleton'
import { useSpkFarm } from './logic/useSpkFarm'
import { SpkFarmView } from './views/SpkFarmView'
import { withSuspense } from '@/ui/utils/withSuspense'

function SpkFarmContainer() {
  const spkFarm = useSpkFarm()

  return <SpkFarmView {...spkFarm} />
}

const SpkFarmContainerWithSuspense = withSuspense(SpkFarmContainer, SpkFarmSkeleton)
export { SpkFarmContainerWithSuspense as SpkFarmContainer }
